'use client'
import React from 'react'
import Modal from '@/components/Modal'
import { Button, QRCode } from 'antd'
import styles from './page.module.scss'
import Image from 'next/image'
import { useLocale } from 'core/components/Locale'

interface InstallWalletProps {
  visible: boolean
  onCancel: () => void
}

const InstallWalletModal: React.FC<InstallWalletProps> = ({ visible, onCancel }) => {
  const t = useLocale()
  const href = 'https://www.hotcoin.cc/zh_CN/app/downLoad/'
  return (
    <>
      <Modal
        className={styles.install_wallet_modal}
        closeOnMaskClick={false}
        open={visible}
        width={756}
        onClose={onCancel}
      >
        <div className={styles.install_wallet_content}>
          <div className={styles.left}>
            <div className={styles.title}>{t('hotcoinWeb_v1_12_2128889_InstallHotcoinWallet')}</div>
            <div className={styles.desc}>{t('hotcoinWeb_v1_12_2128889_ConnectToYourInternet')}</div>
            <div className={styles.imgDiv}>
              {/* <Image className={styles.image} alt="image" width={135} height={135} unoptimized src={''} /> */}
              <QRCode size={126} bordered={false} value={href} />
            </div>
            <div className={styles.download}>
              <div className={styles.text}>{t('hotcoinWeb_v1_12_2128889_ScanTheQRCode')}</div>
              <div className={styles.text2}>IOS & Android</div>
              <Button className={styles.btn} onClick={() => window.open(href)}>
                {t('hotcoinWeb_v1_22_21_MoreDownloadOptions')}
              </Button>
            </div>
          </div>
          <div className={styles.right}></div>
        </div>
      </Modal>
    </>
  )
}

export default InstallWalletModal
